import React, {useEffect} from 'react';
import {CmsBannerId} from '../../services/cms/cms-banners/cm-banner-id/cms-banner-id';
import {observer} from 'mobx-react';
import {EmptyBannerDefinition} from '../../services/cms/cms-banners/banner-definition/empty-banner-definition';
import {BannerContainerBox} from "./banner-container/banner-container.box";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";
import {EmptyBannerComponent} from "./empty-banner/empty-banner.component";

export interface CmsBannerComponentProps {
    componentID: string;
    templateID: string;
    fallbackComponent: string;
    showPlaceholder: boolean;
    className?: string;
    minHeight?: string;
}
interface CmsBannerComponentWithServicesProps extends CmsBannerComponentProps, ComponentServicesPick<'cmsBanners'>{

}

const ComponentBody: React.FC<CmsBannerComponentWithServicesProps> = observer((props) => {

    const bannerId = new CmsBannerId(props.componentID, props.templateID, props.fallbackComponent);

    useEffect(() => {
        props.cmsBanners.loadBanner(bannerId)
    });

    let bannerDefinition = props.cmsBanners.bannersMap[bannerId.key];
    if(!bannerDefinition) {
        bannerDefinition = new EmptyBannerDefinition();
    }


    return (
        <BannerContainerBox minHeight={props.minHeight}
                            className={`cy-cms-banner-container tcmid-${bannerId.componentID} ${props.className || ''}`}>
            {
                bannerDefinition.render({
                    showPlaceholder: props.showPlaceholder,
                    minHeight: props.minHeight
                })
            }
        </BannerContainerBox>
    );
});

export const CmsBannerComponent = withServices(ComponentBody,
                                                            ['cmsBanners'],
    {
        renderSkeleton: (props) => <EmptyBannerComponent showPlaceholder={props.showPlaceholder} minHeight={props.minHeight}/>
    });